// extracted by mini-css-extract-plugin
export var divider = "_vn-0";